import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { format, addDays } from "date-fns";
// import Alert from "react-bootstrap/Alert";
import "../../styles/payment-link/cupon-requests.css";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../common-components/CommonStructured";
import CommonFilterStructure from "../common-components/CommonFilterStructure";
import CuponRequestTabs from "./CuponRequestTabs";
import WelcomeUser from "../Open-pages/user/WelcomeUser";
import BackAddBtns from "../Open-pages/target-matrics/common/BackAddBtns";

const CuponRequestLists = ({ userInfoData, isCustom }) => {
  const navigate = useNavigate();
  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);
  // const isNotificationDenied = useSelector(
  //   (state) => state.notification.permission
  // );

  const [selectedTab, setSelectedTab] = useState(0);
  const [isPage, setIsPage] = useState(0);
  const [openDateRanger, setOpenDateRanger] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);
  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selectedStatus: "",
    selectedPlan: "",
    selectedStartDate: "",
    selectedEndDate: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    status: allFilters.selectedStatus?.value || "",
    gym_id:
      !isAdmin && !isManagerRole
        ? userInfoData?.gym_id || userInfoData?.user_id || userInfoData?.uid
        : allFilters.selectedGym?.value || "",
    plan_id: allFilters.selectedPlan?.label || "",
    start_date: allFilters.selectedStartDate || "",
    end_date: allFilters.selectedEndDate || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [getComineReload, setGetComineReload] = useState(false);

  function onResetFilters() {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
    setSearchFilterApplied(false);
    setIsPage(0);
  }

  const handleTabSelect = (index) => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedStatus:
        index !== 0
          ? {
              label:
                index === 1
                  ? "Pending"
                  : index === 2
                  ? "Approved"
                  : index === 3
                  ? "Cancelled"
                  : index === 4
                  ? "Removed"
                  : "",
              value:
                index === 1
                  ? "pending"
                  : index === 2
                  ? "approved"
                  : index === 3
                  ? "cancelled"
                  : index === 4
                  ? "removed"
                  : "",
            }
          : "",
    }));

    setSelectedTab(index);
    setIsPage(0);
  };

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
      setIsPage(0);
    }
  };

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    setAllFilters({
      ...allFilters,
      selectedStartDate: formattedStartDate,
      selectedEndDate: formattedEndDate,
    });
  };

  const clearDateRanger = () => {
    setOpenDateRanger(false);
    setRangeState(initialRangeState);
    setAllFilters({
      ...allFilters,
      selectedStartDate: "",
      selectedEndDate: "",
    });
  };

  const handleBack = (e) => {
    e.preventDefault();

    navigate("/open-access/all-pages", {
      state: { userInfo: userInfoData, decryptedText: userInfoData },
    });
  };

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: !isAdmin  && !isClusterManager
  //       ? {
  //           label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
  //           value:
  //             userInfoData?.gym_id ||
  //             userInfoData?.user_id ||
  //             userInfoData?.uid ||
  //             "",
  //         }
  //       : "",
  //   }));
  // }, [userInfoData?.gym_id]);

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedPlan: "",
    }));
  }, [allFilters.selectedGym]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      status: allFilters.selectedStatus?.value || "",
      gym_id:
        !isAdmin && !isManagerRole
          ? userInfoData?.gym_id || userInfoData?.user_id || userInfoData?.uid
          : allFilters.selectedGym?.value || "",
      plan_id: allFilters.selectedPlan?.value || "",
      start_date: allFilters.selectedStartDate || "",
      end_date: allFilters.selectedEndDate || "",
    }));
  }, [
    isPage,
    allFilters.selectedGym,
    allFilters.selectedStatus,
    allFilters.selectedPlan,
    allFilters.selectedStartDate,
    allFilters.selectedEndDate,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Membership Request Approval">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        {isCustom && (
          <>
            <Row>
              <Col>
                <WelcomeUser userName={userInfoData?.name} />
                {/* {isNotificationDenied === "denied" && (
                  <Alert variant={"danger"} className="mt30">
                    Notification permission is denied. Unable to display desktop
                    notifications.
                  </Alert>
                )} */}
              </Col>
            </Row>

            <Row>
              <Col>
                <BackAddBtns
                  isCustom={isCustom}
                  onClickBack={isCustom ? handleBack : null}
                  onClickReload={() => setGetComineReload(true)}
                  isAddBtn={false}
                />
              </Col>
            </Row>
          </>
        )}

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Membership Request Approval"}
              isReload={() => setGetComineReload(true)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CommonFilterStructure
              from={"cupon-request"}
              decryptedText={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              isStatusDisabled={
                selectedTab !== 0 ? allFilters.selectedStatus : null
              }
              openDateRanger={openDateRanger}
              handleDateRangeChange={handleDateRangeChange}
              setOpenDateRanger={setOpenDateRanger}
              rangeState={rangeState}
              clearDateRanger={clearDateRanger}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CuponRequestTabs
              userInfoData={userInfoData}
              isPage={isPage}
              setIsPage={setIsPage}
              filters={filters}
              handleTabSelect={handleTabSelect}
              selectedTab={selectedTab}
              handleReset={() => {
                onResetFilters();
                setSelectedTab(0);
              }}
              getComineReload={getComineReload}
              setGetComineReload={setGetComineReload}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default CuponRequestLists;
